import { render, staticRenderFns } from "./MerchantPromoItem.vue?vue&type=template&id=b8fc3046"
import script from "./MerchantPromoItem.vue?vue&type=script&lang=js"
export * from "./MerchantPromoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports